import { IconDefinition } from "./types";

const telephone: IconDefinition = {
  iconName: "telephone",
  width: 16,
  height: 16,
  svgPathData:
    "M9.891 14.457l.008.004a3.443 3.443 0 004.283-.47l.482-.48a1.148 1.148 0 000-1.624l-2.03-2.028a1.149 1.149 0 00-1.623 0 1.146 1.146 0 01-1.622 0L6.142 6.612a1.148 1.148 0 010-1.623 1.148 1.148 0 000-1.622L4.113 1.336a1.149 1.149 0 00-1.623 0l-.482.482a3.444 3.444 0 00-.47 4.282l.005.008a31.077 31.077 0 008.348 8.349z",
  iconType: "stroke",
};

export { telephone };
